import React, { useState } from 'react';

const EditUserModal = ({ user, onSave, onCancel, roles = [] }) => {
  const [editedUser, setEditedUser] = useState({ ...user });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedUser({ ...editedUser, [name]: value });
  };

  const handleLoginDetailChange = (e) => {
    const { name, value } = e.target;
    setEditedUser({
      ...editedUser,
      LoginDetail: {
        ...editedUser.LoginDetail,
        [name]: value
      }
    });
  };


  const handleSubmit = () => {
    onSave(editedUser);
  };

  return (
    <div className="fixed inset-0 overflow-y-auto z-50">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">

        <div className="fixed inset-0 transition-opacity z-40" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen z-50" aria-hidden="true">&#8203;</span>

        <div className="relative z-50 inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full max-w-md">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className="mt-3 text-left sm:mt-0 sm:ml-4 sm:text-left flex-1">
                <h3 className="text-lg leading-6 font-medium text-gray-900 text-left">Edit User Details</h3>
                <div className="mt-2">
                  <div className="mb-4">
                    <label htmlFor="firstName" className="block text-gray-700 text-sm font-bold mb-2">First Name:</label>
                    <input type="text" id="firstName" name="firstName" value={editedUser.firstName} onChange={handleInputChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="lastName" className="block text-gray-700 text-sm font-bold mb-2">Last Name:</label>
                    <input type="text" id="lastName" name="lastName" value={editedUser.lastName} onChange={handleInputChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="mobile" className="block text-gray-700 text-sm font-bold mb-2">Mobile:</label>
                    <input type="text" id="mobile" name="mobile" value={editedUser.mobile} onChange={handleInputChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                  </div>
                  <div className="mb-4">
                    <label htmlFor="email" className="block text-gray-700 text-sm font-bold mb-2">Email:</label>
                    <input type="email" id="email" name="email" value={editedUser.LoginDetail.email} onChange={handleLoginDetailChange} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" />
                  </div>

                  {
                    user.LoginDetail.UserRole.roleName !== "admin" &&
                    <div className="mb-4">
                      <label htmlFor="roleId" className="block text-gray-700 text-sm font-bold mb-2">User Role</label>
                      <select id="roleId" name="roleId" value={editedUser.LoginDetail.roleId} onChange={handleLoginDetailChange}
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      >
                          <option value="">-- Select Role --</option>
                          {roles.map(role => (
                            <option key={role.id} value={role.id}>{role.roleName}</option>
                          ))}
                      </select>
                    </div>
                  }

                  {
                    user.LoginDetail.UserRole.roleName !== "admin" &&
                    <div className="mb-4">
                      <label htmlFor="status" className="block text-gray-700 text-sm font-bold mb-2">Login Status</label>
                      <select id="status" name="status" value={editedUser.LoginDetail.status ? "true" : "false"} onChange={(e) => handleLoginDetailChange({target: {name: 'status', value: e.target.value === 'true'}})}
                      className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" 
                      >
                          <option value="true">Active</option>
                          <option value="false">Inactive</option>
                      </select>
                    </div>
                  }
                  
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <button onClick={handleSubmit} type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm">
              Save
            </button>
            <button onClick={onCancel} type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditUserModal;
